module.exports = __webpack_public_path__ + "img/server_down.03ff455b.svg";